import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Loading } from "@/pages/Other/Loading";
const data = [
    { name: "Information Technology", value: 35, color: "#3B82F6" },
    { name: "Software Product", value: 29, color: "#60A5FA" },
    { name: "BFSI", value: 15, color: "#A78BFA" },
    { name: "E-commerce", value: 9, color: "#FBBF24" },
    { name: "Others", value: 12, color: "#14B8A6" },
];



const BatchProfile = () => {
    const [image, setImage] = useState(null);
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        async function fetchReasonsData() {
            try {
                const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/businessdata`);
                //console.log("API Response:", response.data); // Log response to debug
                const events = JSON.parse(response.data);
                console.log("API Response:", events);
                setImage(events);  // turns string into array of objects
            }
            catch (error) {
                console.error("Error fetching reasons data:", error);
            }
        }
        fetchReasonsData();
    }, []);

    
    if (!image) {
        return (
            <div className="max-w-7xl mx-auto py-16 px-5 flex flex-col items-center justify-center min-h-[350px]">
                <Loading />
            </div>
        );
    }

    return (
        <div className="max-w-7xl mx-auto py-12 px-6 font-sans">
            {/* Header section with modern badge */}
            <div className="relative mb-10">
                <span className="text-xs font-bold text-[#264b82] uppercase tracking-widest bg-blue-50/70 border border-blue-100/50 px-4 py-1.5 rounded-full shadow-sm inline-block">
                    {t("Cohort Stats")}
                </span>
                <h2 className="text-4xl font-extrabold text-gray-900 mt-4 tracking-tight">
                    Batch Profile
                </h2>
                <div className="w-16 h-1.5 bg-[#264b82] mt-3 rounded-full shadow-sm"></div>
                <p className="text-gray-500 mt-4 text-base md:text-lg max-w-3xl leading-relaxed">
                    This program caters to working professionals from various industries and backgrounds. The diversity of our students enhances discussions and interactions.
                </p>
            </div>

            {/* Main Accordion Container */}
            <div className="border border-slate-200/80 rounded-2xl overflow-hidden bg-white shadow-[0_12px_36px_rgba(0,0,0,0.03)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.05)] transition-all duration-300">
                <h2 id="accordion-color-heading-1">
                    <button
                        type="button"
                        onClick={() => setIsOpen(!isOpen)}
                        className={`flex items-center justify-between w-full p-6 font-bold text-gray-800 transition-all duration-300 ${isOpen ? "bg-gradient-to-r from-slate-50 to-white border-b border-slate-100" : "bg-white"}`}
                        style={{
                            borderLeft: "6px solid #264b82"
                        }}
                    >
                        <span className="text-lg tracking-tight flex items-center gap-2.5">
                            📊 Program Demographics & Partner Network
                        </span>
                        <svg 
                            className={`w-4 h-4 shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180 text-[#264b82]" : "text-gray-400"}`} 
                            aria-hidden="true" 
                            xmlns="http://www.w3.org/2000/svg" 
                            fill="none" 
                            viewBox="0 0 10 6"
                        >
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5 5 1 1 5" />
                        </svg>
                    </button>
                </h2>
                
                {isOpen && (
                    <div className="p-6 md:p-8 bg-gradient-to-b from-white to-slate-50/50">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            
                            {/* Industry Breakdown Card */}
                            <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-[0_4px_20px_rgba(0,0,0,0.015)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.03)] transition-all duration-300 flex flex-col justify-between">
                                <div>
                                    <div className="flex items-center gap-2 mb-2">
                                        <div className="w-1.5 h-6 bg-[#264b82] rounded-full"></div>
                                        <h3 className="text-xl font-bold text-gray-900">Industry Breakdown</h3>
                                    </div>
                                    <p className="text-sm text-gray-400 mb-6 font-medium">Distribution across different target domains</p>
                                    
                                    <div className="flex flex-col md:flex-row items-center justify-center gap-8 mt-4">
                                        {/* Centered Pie Chart */}
                                        <div className="w-full md:w-1/2 flex justify-center drop-shadow-[0_10px_20px_rgba(0,0,0,0.04)]">
                                            <PieChart width={280} height={280}>
                                                <Pie
                                                    data={data}
                                                    cx="50%"
                                                    cy="50%"
                                                    innerRadius={55}
                                                    outerRadius={95}
                                                    fill="#8884d8"
                                                    paddingAngle={4}
                                                    dataKey="value"
                                                    label={false}
                                                >
                                                    {data.map((entry, index) => (
                                                        <Cell key={`cell-${index}`} fill={entry.color} stroke="#fff" strokeWidth={2} />
                                                    ))}
                                                </Pie>
                                                <Tooltip 
                                                    contentStyle={{
                                                        background: "rgba(15, 23, 42, 0.95)",
                                                        border: "none",
                                                        borderRadius: "12px",
                                                        color: "#fff",
                                                        boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                        padding: "10px 14px",
                                                    }}
                                                    itemStyle={{ color: "#fff", fontWeight: "700" }}
                                                    labelStyle={{ display: "none" }}
                                                />
                                            </PieChart>
                                        </div>

                                        {/* Legend List */}
                                        <div className="w-full md:w-1/2">
                                            <ul className="space-y-3">
                                                {data.map((entry, index) => (
                                                    <li 
                                                        key={index} 
                                                        className="flex items-center justify-between p-3 rounded-xl bg-slate-50 border border-slate-100 shadow-[0_2px_4px_rgba(0,0,0,0.01),_inset_0_-1px_0_rgba(0,0,0,0.02)] hover:shadow-[0_4px_10px_rgba(0,0,0,0.03)] hover:scale-[1.02] hover:border-slate-200 transition-all duration-200"
                                                    >
                                                        <div className="flex items-center gap-3">
                                                            <span className="w-3.5 h-3.5 rounded-full shadow-inner" style={{ backgroundColor: entry.color }}></span>
                                                            <span className="text-gray-700 font-semibold text-sm">{entry.name}</span>
                                                        </div>
                                                        <span className="bg-slate-200 font-extrabold text-xs px-2.5 py-1 rounded-full shadow-inner" style={{ color: entry.color, background: `${entry.color}15` }}>
                                                            {entry.value}%
                                                        </span>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Recruiter Partners Card */}
                            <div className="bg-white border border-slate-100 rounded-2xl p-6 shadow-[0_4px_20px_rgba(0,0,0,0.015)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.03)] transition-all duration-300">
                                <div className="flex items-center gap-2 mb-2">
                                    <div className="w-1.5 h-6 bg-[#264b82] rounded-full"></div>
                                    <h3 className="text-xl font-bold text-gray-900">Featured Recruiter Network</h3>
                                </div>
                                <p className="text-sm text-gray-400 mb-6 font-medium">Top global brands recruiting from our alumni pool</p>
                                
                                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5">
                                    {image?.companies?.map((company, index) => (
                                        <div 
                                            key={index} 
                                            className="flex justify-center items-center bg-white border border-slate-100 rounded-xl p-4 shadow-[0_2px_8px_rgba(0,0,0,0.025),_inset_0_-2px_0_rgba(0,0,0,0.015)] hover:shadow-[0_12px_24px_rgba(0,0,0,0.06)] hover:-translate-y-1.5 transition-all duration-300 cursor-pointer"
                                        >
                                            <img
                                                src={`${process.env.REACT_APP_COURSE_API_BASEURL}${company.logo}`}
                                                alt={company.name}
                                                className="h-10 w-24 object-contain filter grayscale hover:grayscale-0 transition-all duration-300"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default BatchProfile;
